import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { AdminFormRow, AdminFormSection } from '@ui';
import { ControlledSelect } from '@lp/features/admin/forms/components/inputs/ControlledSelect';
import { EmployeeFormValues } from '@/types';
import { getFormattedLiverRegionsList, getFormattedHeartLungsRegionsList } from '@/utils/helpers';
import { useAllRegionsListQuery } from '@/queries/regions';
import { OrganType } from '@/api/apis/case';

type RetrievalSurgeonSpecificationSectionProps = {
  isReadOnly?: boolean;
};

export const RetrievalSurgeonSpecificationSection = memo(
  ({ isReadOnly }: RetrievalSurgeonSpecificationSectionProps) => {
    const { control } = useFormContext<EmployeeFormValues>();

    const [organType] = useWatch({
      control,
      name: ['organType'],
    });

    const { data: regionsList } = useAllRegionsListQuery();

    const isOrganLiver = organType?.includes(OrganType.Liver);
    const isOrganHeartAndLungs = organType?.includes(OrganType.Heart) || organType?.includes(OrganType.Lungs);

    if (!organType?.length) return null;

    return (
      <AdminFormSection title="Retrieval Surgeon Specification">
        {isOrganLiver && (
          <AdminFormRow title="Liver Surgeon Region" isRequired>
            <ControlledSelect
              name="liverSurgeonRegionId"
              placeholder="Choose an option"
              aria-label="Liver Surgeon Region"
              isDisabled={isReadOnly}
              items={getFormattedLiverRegionsList(regionsList)}
            />
          </AdminFormRow>
        )}
        {isOrganHeartAndLungs && (
          <AdminFormRow title="Heart & Lungs Surgeon Region" isRequired>
            <ControlledSelect
              name="heartLungsSurgeonRegionId"
              placeholder="Choose an option"
              aria-label="Heart & Lungs Surgeon Region"
              isDisabled={isReadOnly}
              items={getFormattedHeartLungsRegionsList(regionsList)}
            />
          </AdminFormRow>
        )}
      </AdminFormSection>
    );
  },
);
